import { Search, FileText, GraduationCap, Users, ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { useSite } from "@/context/SiteContext";
import { TRUST_BADGES } from "./Hero";

const icons = [Search, FileText, GraduationCap, Users];

export default function Process() {
  const { content, openBooking } = useSite();
  const steps = content.process?.steps || [];

  return (
    <section id="process" className="section-pad relative overflow-hidden text-white">
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{ backgroundImage: "url(/process-bg.png)", backgroundSize: "cover", backgroundPosition: "center", filter: "blur(18px)", transform: "scale(1.12)" }}
      />
      <div aria-hidden="true" className="absolute inset-0 bg-[rgba(5,13,26,0.74)]" />
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-10 text-center">
        <Reveal direction="up">
          <div className="eyebrow text-[#00CFFF] mb-4">Our Matching Process</div>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-[46px] tracking-tight leading-[1.12]">
            We find the <span className="text-[#00CFFF]">right fit</span> for your team.
          </h2>
          <p className="mt-4 text-slate-300 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            We take the time to understand your needs and connect you with trained specialists who are the right fit for your goals.
          </p>
        </Reveal>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6 text-left">
          {steps.map((s, i) => {
            const Icon = icons[i % 4];
            return (
              <Reveal key={i} direction="up" delay={i * 0.12} className="h-full">
                <div
                  className="h-full rounded-2xl border border-[rgba(0,207,255,0.45)] bg-[rgba(7,16,32,0.55)] backdrop-blur-md p-7 shadow-[0_0_28px_rgba(0,191,255,0.16),0_18px_44px_rgba(0,0,0,0.35)] transition-all duration-300 hover:shadow-[0_0_44px_rgba(0,191,255,0.3),0_22px_54px_rgba(0,0,0,0.42)] hover:-translate-y-1"
                  data-testid={`process-step-${i + 1}`}
                >
                  <div className="flex items-center gap-3.5">
                    <span className="font-display font-black text-cyan-400 text-[26px] leading-none">{String(i + 1).padStart(2, "0")}</span>
                    <span className="w-10 h-10 rounded-full border border-[rgba(0,207,255,0.5)] bg-[rgba(0,207,255,0.08)] flex items-center justify-center">
                      <Icon size={18} className="text-cyan-300" strokeWidth={2.2} />
                    </span>
                  </div>
                  <h3 className="mt-5 font-display font-extrabold text-white text-xl">{s.title}</h3>
                  <p className="mt-2.5 text-[14.5px] text-slate-300 leading-relaxed">{s.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal direction="up" delay={0.15}>
          <div className="mt-12 flex justify-center">
            <button
              className="btn rounded-full"
              style={{ background: "#00CFFF", color: "#062033", boxShadow: "0 0 30px rgba(0,207,255,0.45)" }}
              onClick={() => openBooking(null, "booking")}
              data-testid="process-cta-consultation"
            >
              Book a Free Consultation <ArrowRight size={17} strokeWidth={2.5} />
            </button>
          </div>
        </Reveal>

        <Reveal direction="up" delay={0.2}>
          <div className="mt-12 flex items-center justify-center gap-5 sm:gap-8 flex-wrap">
            {TRUST_BADGES.map((b, i) => (
              <div key={b.l1} className="flex items-center gap-5 sm:gap-8">
                {i > 0 && <span className="w-px h-10 bg-white/25 hidden sm:block" />}
                <div className="flex items-center gap-3">
                  <span className="w-11 h-11 rounded-full bg-[#1D6FF2] shadow-lg shadow-blue-900/50 flex items-center justify-center flex-shrink-0">
                    <b.icon size={19} className="text-white" strokeWidth={2.4} />
                  </span>
                  <span className="text-[13px] font-bold text-white leading-tight text-left" style={{ textShadow: "0 1px 12px rgba(4,10,24,0.8)" }}>
                    {b.l1}<br />{b.l2}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
